import { render, staticRenderFns } from "./AlertSettings.vue?vue&type=template&id=59b39c2c&scoped=true"
import script from "./AlertSettings.vue?vue&type=script&lang=js"
export * from "./AlertSettings.vue?vue&type=script&lang=js"
import style0 from "./AlertSettings.vue?vue&type=style&index=0&id=59b39c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b39c2c",
  null
  
)

export default component.exports